import { Pipe, PipeTransform } from '@angular/core';
import { Assessment, BbsData } from '../services/model';

@Pipe({
  name: 'bbsScore',
  standalone: true,
})
export class BbsScorePipe implements PipeTransform {
  transform(assessment: Assessment, option: 'grenzwert' | 'diff' | 'festgestellt'): string {
    if (assessment.type === 'BBS') {
      const grenzwert = 45;
      if (option === 'grenzwert') {
        return grenzwert + ' Pkt.';
      } else {
        const data = assessment.data as BbsData;
        let score = 0;
        data.bbs.data.forEach(subSubTest => (score += subSubTest.value ?? 0));
        let diff = 0;
        if (score && score > -1) {
          diff = grenzwert - score;
          if (option === 'festgestellt') {
            if (diff > 0) {
              return '<b>Ja</b>';
            } else {
              return 'Nein';
            }
          } else if (option === 'diff') {
            if (diff > 0) {
              return '(+ ' + diff + ' Pkt.)';
            }
          }
        }
      }

      return '';
    } else {
      return '';
    }
    return '';
  }
}
